import ManageSpecializationsForm from './ManageSpecializationsForm';

export default ManageSpecializationsForm;
